import { useEditorStore } from '@/features/editor/stores/editor-store'
import { SectionCard } from './section-card'

export function MetaSection() {
  const draft = useEditorStore((s) => s.draft)
  const patchDraft = useEditorStore((s) => s.patchDraft)

  return (
    <SectionCard
      title='基本信息'
      description='填写名称与简介，用于展示和识别你的世界卡'
    >
      <div className='grid gap-2'>
        <label className='text-sm font-medium'>世界卡名称</label>
        <input
          className='bg-background border-border placeholder:text-muted-foreground hover:bg-background/80 focus-visible:border-ring focus-visible:ring-ring/30 h-10 w-full rounded-md border px-3 text-sm transition outline-none focus-visible:ring-2'
          value={draft.title}
          onChange={(e) => patchDraft({ title: e.target.value })}
          placeholder='例如：Originpoint'
          maxLength={40}
        />
      </div>

      <div className='grid gap-2'>
        <label className='text-sm font-medium'>世界简介</label>
        <textarea
          className='bg-background border-border placeholder:text-muted-foreground hover:bg-background/80 focus-visible:border-ring focus-visible:ring-ring/30 min-h-[96px] w-full resize-none rounded-md border px-3 py-2 text-sm transition outline-none focus-visible:ring-2'
          value={draft.description}
          onChange={(e) => patchDraft({ description: e.target.value })}
          placeholder='为您的世界进行简要说明，如剧情概要、注意事项、玩家定位等'
        />
      </div>
    </SectionCard>
  )
}
